<template>
  <Content>
    <div class="container-fluid py-4">
      <div v-if="loading" class="text-center py-5">
        <!-- <div class="spinner-border text-primary"></div> -->
      </div>

      <div v-else class="row g-4">
        <DashboardCard
          :title="currentLang.usersCount"
          :value="stats.users_count"
          subTitle="Total Registered"
          gradientClass="bg-gradient-blue"
        />
        <DashboardCard
          :title="currentLang.pendingOrders"
          :value="stats.pending_orders_count"
          subTitle="Awaiting Action"
          gradientClass="bg-gradient-cyan"
        />
        <DashboardCard
          :title="currentLang.invoices"
          :value="stats.invoices_count"
          subTitle="Total Invoices"
          gradientClass="bg-gradient-purple"
        />
        <DashboardCard
          :title="currentLang.lowStock"
          :value="stats.low_stock_products_count"
          subTitle="Critical Items"
          gradientClass="bg-gradient-green"
        />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card chart-card shadow-sm border-0">
            <div class="card-body">
              <h5 class="card-title fw-bold mb-4">
                {{ currentLang.ordersChartTitle }}
              </h5>
              <div class="chart-container">
                <Line
                  v-if="chartData.labels.length"
                  :data="chartData"
                  :options="chartOptions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Content>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import Content from "@/components/AdminContent.vue";
import DashboardCard from "@/components/DashboardCard.vue";
import { lang } from "@/plugins/lang";
import api from "@/plugins/axios";
import { showLoading, hideLoading } from "@/stores/loading";


import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

import enText from "@/locales/en/AdminDashboard";
import faText from "@/locales/fa/AdminDashboard";

const translations = {
  en: enText,
  fa: faText,
};

const currentLang = computed(() => translations[lang.value]);
const loading = ref(true);
const stats = ref({});
const chartData = ref({ labels: [], datasets: [] });

// تنظیمات ظاهری نمودار برای زیبایی بیشتر
const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 1, 
        precision: 0, 
      },
      grid: { drawBorder: false, color: "#f0f0f0" },
    },
    x: { grid: { display: false } },
  },
  elements: {
    line: { tension: 0.4 }, // ایجاد خط منحنی (Smooth)
  },
};

const fetchData = async () => {
  try {
    loading.value = true;
    showLoading();

    // اجرای هر دو API به صورت همزمان برای سرعت بیشتر
    const [statsRes, chartRes] = await Promise.all([
      api.get("admin/dashboard/get-info"),
      api.get("admin/dashboard/orders-last-10-days"),
    ]);

    if (statsRes.data.success) stats.value = statsRes.data.data;

    if (chartRes.data.success) {
      chartData.value = {
        labels: chartRes.data.data.labels,
        datasets: [
          {
            label: currentLang.value.pendingOrders,
            backgroundColor: "rgba(76, 201, 240, 0.1)",
            borderColor: "#4361ee",
            pointBackgroundColor: "#4361ee",
            fill: true,
            data: chartRes.data.data.values,
          },
        ],
      };
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
    hideLoading();

  }
};

onMounted(fetchData);
</script>


<style scoped>
.chart-card {
  border-radius: 16px;
  padding: 1rem;
}
.chart-container {
  height: 350px;
}
</style>